// Shared by the attendee room and the host broadcast page.
//
// A sender receives its own message twice — POST response and ActionCable echo
// — so merging by id keeps exactly one entry whichever arrives first.
export function mergeChatMessage(list, message) {
  if (!message?.id) return list;
  if (list.some((m) => m.id === message.id)) return list;
  return [ ...list, message ];
}
